import * as actions from './actions';
import * as selectors from './selectors';

const sidebar = { actions, selectors };
export default sidebar;
